/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Perm_Money_Loop_MetricsInputs */

const vi_api_keys_perm_money_loop_metrics = /** @type {(inputs: Api_Keys_Perm_Money_Loop_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ số dòng tiền`)
};

/**

* @param {Api_Keys_Perm_Money_Loop_MetricsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_perm_money_loop_metrics = /** @type {((inputs?: Api_Keys_Perm_Money_Loop_MetricsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Perm_Money_Loop_MetricsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_perm_money_loop_metrics(inputs)
});